<div class="card">
  <div class="card-header">
    {{ data.title }}
  </div>
  <div class="card-body">
    {{ data.message }}
  </div>
  <div class="card-footer">
    <div class="d-flex justify-content-end w-100 gap-1">
      <button (click)="onClickClose()" color="warn" mat-button>No</button>
      <button (click)="onClickOk()" cdkFocusInitial color="primary" mat-button>Ok</button>
    </div>
  </div>
</div>
